<div class="flex-row navigation-container">
  <section class="navigation-header-logo">
    <ng-content select="wchfs-nav-logo"></ng-content>
  </section>
  <section class="navigation-header-items flex-row">
    <ng-content select="wchfs-nav-header-item"></ng-content>
  </section>
</div>
